import axios from 'axios';

export default {
  async setClientWithWallet(context, clientID) {
    await axios
      .get(`/Basic/Client/GetClientWithWalletForSite?id=${clientID}`)
      .then((response) => {
        sessionStorage.setItem('clientID', response.data.id);
        sessionStorage.setItem('clientWalletID', response.data.walletID);
        sessionStorage.setItem('clientFirstName', response.data.firstName);
        sessionStorage.setItem('clientLastName', response.data.lastName);
        sessionStorage.setItem('balance', response.data.walletBalances);
        sessionStorage.setItem('isOverseas', response.data.isOverseas);
        sessionStorage.setItem('email', response.data.email);
        sessionStorage.setItem('clientCode', response.data.clientCode);
        sessionStorage.setItem('phone', response.data.phone);
        context.rootState.inMaintenance = response.data.inMaintenance ?? false;

        context.commit('setClient', {
          clientID: response.data.id,
          walletID: response.data.walletID,
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          balance: response.data.walletBalances,
          isOverseas: response.data.isOverseas,
          email: response.data.email,
          clientCode: response.data.clientCode,
          phone: response.data.phone,
        });
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  async setClientList(context, clientsData) {
    sessionStorage.setItem('clientList', JSON.stringify(clientsData));
    context.commit('setClientList', clientsData);
  },
  setClientWorkshopSearchModel(context, searchModel) {
    // debugger;
    // sessionStorage.setItem('workshopSearchModel', JSON.stringify(searchModel));
    context.commit('setWorkshopFilter', searchModel);
  },
  setClientCurrentPanel(context, currentPanel) {
    // debugger;
    // sessionStorage.setItem('workshopSearchModel', JSON.stringify(searchModel));
    context.commit('setCurrentPanel', currentPanel);
  },
};
